import React from "react";
import css from "./Contact.module.css";
import { ReactComponent as CheckCircleIcon } from "../../Assets/svg/check_circle.svg";

const Completed = () => {
  return (
    <div className={css.CompletedBox}>
      <CheckCircleIcon className={css.CheckCircle} />
      <h2 className={css.Title}>Thank you for completing the survey.</h2>
      <p className={css.Details}>
        Your details have been received and will help us prepare for a smooth
        installation. We'll be in touch soon!
      </p>
    </div>
  );
};

export default Completed;
